import React from 'react';
import ProfileAvatar from '../common/ProfileAvatar';

export default function UserManagementAvatar({ user, displayName }) {
  return (
    <ProfileAvatar
      uid={user.id}
      photoURL={user.photoURL}
      displayName={displayName}
      authorColor={user.chatColor || user.authorColor}
      className="user-management-user-cell__avatar"
      photoClassName="user-management-user-cell__avatar user-management-user-cell__avatar--photo"
      initialsClassName="user-management-user-cell__avatar"
    />
  );
}
